// PlanViewerWithPopup.js
import React, { useState } from 'react';
import { 
  Paper, 
  Typography, 
  Box, 
  IconButton, 
  Dialog, 
  DialogTitle, 
  DialogContent,
  DialogActions,
  Button,
  useTheme
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';
import {labelTextStyles} from "../../RnDMember/ExitRequestResponseUnified/ExitRequestResponseStyles";

export const PlanViewerWithPopup = ({ title, content, height = 250 }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box sx={{ position: 'relative' }}>
          <Typography variant="body2" color="textSecondary" sx={{...labelTextStyles, mt: 1, fontSize: '0.95rem'}}>
          {title}
        </Typography>
        <Paper 
          variant="outlined" 
          sx={{ 
            p: 2, 
            mb: 0,
            bgcolor: "#f5f5f5",
            height: `${height}px`,
            overflow: 'auto',
            position: 'relative'
          }}
        >
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
            {content || `No ${title.toLowerCase()} details provided.`}
          </Typography>
        </Paper>
        <IconButton 
          onClick={handleOpen}
          size="small"
          sx={{
            transform:"scale(0.8)",
            position: 'absolute', 
            right: 8, 
            top: 32,
            bgcolor: 'rgba(255, 255, 255, 0.7)',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.9)',
              color: theme.palette.primary.main
            }
          }}
          aria-label={`Expand ${title}`}
        >
          <OpenInFullIcon />
        </IconButton>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        aria-labelledby={`${title}-dialog-title`}
        PaperProps={{
            sx: {
                borderRadius: '8px',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                height:"100vh"
            }
        }}
      >
        <DialogTitle 
          id={`${title}-dialog-title`}
          sx={{
              bgcolor: '#f0f6ff',
              color: theme.palette.primary.main,
              fontWeight: 600,
              borderBottom: '1px solid #e0e0e0',
              py: 1.5
          }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#757575',
              '&:hover': {
                color: theme.palette.primary.main,
                bgcolor: 'rgba(25, 118, 210, 0.08)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
          <DialogContent
              sx={{
                  pb: 0,
                  pt: 0,
                  px: 2,
                  bgcolor: '#f8f9fa'
              }}
          >
          <Box sx={{
            mt: 1.5,
            height: '75vh',
            overflow: 'auto',
            bgcolor: '#f5f5f5', // Lighter gray background for the plan text
            p: 2,
            borderRadius: '4px',
            border: '1px solid #e0e0e0'
          }}>
            <Typography
                autoFocus
                multiline
                rows={23}
                fullWidth
              variant="body1"
                sx={{
                    mt: 1.5,
                    '& .MuiOutlinedInput-root': {
                        bgcolor: '#ffffff',

                        padding: '0px 0px',
                    },
                    '& .MuiOutlinedInput-input': {
                        bgcolor: '#ffffff',
                        fontSize: '1.5rem',
                        height: '73vh !important',
                        padding: '10px 10px',
                    }
                }}
            >
              {content || `No ${title.toLowerCase()} details provided.`}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ bgcolor: '#f8f9fa', py: 1.5, px: 2 }}>
          <Button 
            onClick={handleClose}
            variant="contained"
            color="primary"
            sx={{
              textTransform: 'none',
              px: 3,
              fontWeight: 500
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};